define ['./disclaimer.css'], () ->
  ($scope, $state, $stateParams, $http, RentappService, RENTAPPLICATION_API_URL) ->
    $scope.secure_svg = require('./../secure.svg')

    $scope.context = $stateParams.context
    $scope.application = $stateParams.application
    $scope.vendor = $stateParams.vendor
    $scope.display_edit_link = false
    $scope.error_message = null

    $scope.vendor_name = if $scope.vendor == 'smartmove' then 'Transunion' else 'Experian'

    $scope.go_edit = () ->
      $state.go "root.applications.edit", { application_id: $scope.application.id }

    $scope.go_next = (context) ->
      if context == 'landlord'
        $state.go("root.verifications.personal_info", { context: context })

      if context == 'applicant'
        if $scope.vendor == 'smartmove'
          $scope.loading = true
          $http.post("#{RENTAPPLICATION_API_URL}/api/v1/application/#{$scope.application.id}/smartmove_get_applicant_questions/")
          .then (response) ->
            if response.data.skip_verification
              $state.go("root.applications.verify.verify_success", { context: context })
            else
              $state.go("root.applications.verify.questions", { questions: response.data.questions })
          .catch (response) ->
            if response.data.applicant_info_update_required
              $scope.display_edit_link = true
            $scope.error_message = response.data.message
            console.log(response)
          .finally ->
            $scope.loading = false
        else
          $state.go("root.applications.verify.personal_info", {application: $scope.application})

      if context == 'applicant-payment'
        $state.go("root.payment.verify.personal_info", {application: $scope.application})



// WEBPACK FOOTER //
// ./components/verifications/disclaimer/disclaimer.coffee